<span *ngIf="isLabel"><b>Totals</b></span>
